import { SupplierHearingCapacityListRes } from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class GetHearingCapacityGateway {
  /** 業者ヒアリング(労務能力)-明細取得 */
  static getSupplierHearingCapacityList = async (
    /** シミュレーション年月度 */
    simulationYm: string,
    /** 業者コード */
    supplierCd: string,
    /** 工場コード */
    factoryCd: string,
    /** 費目コード */
    expenseCd: string,
    /** 業者支店コード */
    supplierBranchCd: string,
    /** 表示開始年度 */
    displayStartYear: string
  ) => {
    const params = {
      simulationYm,
      supplierCd,
      factoryCd,
      expenseCd,
      supplierBranchCd,
      displayStartYear
    }
    return await yamadumiApi.get<SupplierHearingCapacityListRes>(
      '/api/supplier/hearing/capacity/list',
      params
    )
  }
}
